import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DotsProgress } from "shared-ts-ui-progress";

export const DefaultPendingComponent: FC = () => {
  const { t } = useTranslation("shared-ts-router"); //
  return (
    <Stack
      sx={{
        flexGrow: 1,
        minWidth: 0,
        minHeight: 0,
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography>
        {t("Loading")}
        <DotsProgress />
      </Typography>
    </Stack>
  );
};
